import { render, staticRenderFns } from "./CallStatisticsPopup.vue?vue&type=template&id=079736d3&scoped=true&"
import script from "./CallStatisticsPopup.vue?vue&type=script&lang=js&"
export * from "./CallStatisticsPopup.vue?vue&type=script&lang=js&"
import style0 from "./CallStatisticsPopup.vue?vue&type=style&index=0&id=079736d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079736d3",
  null
  
)

export default component.exports